import { useState } from "react"

function BuscadorPaciente({ pacientes, value, onChange }) {
  const seleccionado = pacientes.find(p => String(p.id) === String(value)) || null
  const [query, setQuery]   = useState("")
  const [abierto, setAbierto] = useState(false)

  const filtrados = query.trim()
    ? pacientes.filter(p => {
        const q = query.toLowerCase()
        return (
          p.apellido?.toLowerCase().includes(q) ||
          p.nombre?.toLowerCase().includes(q) ||
          p.dni?.toLowerCase().includes(q) ||
          p.nroSocio?.toLowerCase().includes(q)
        )
      })
    : pacientes

  const handleSelect = (p) => {
    onChange(p.id)
    setQuery("")
    setAbierto(false)
  }

  return (
    <div className="buscadorPaciente">
      <input
        type="text"
        placeholder={seleccionado ? `${seleccionado.apellido}, ${seleccionado.nombre}` : "nombre, DNI o n° socio..."}
        value={query}
        onChange={e => {
          setQuery(e.target.value)
          setAbierto(true)
          if (!e.target.value) onChange("")
        }}
        onFocus={() => setAbierto(true)}
        onBlur={() => setAbierto(false)}
        style={{ width: 240 }}
      />
      {abierto && (
        <div className="buscadorPacienteDropdown">
          {filtrados.length === 0 ? (
            <div className="buscadorPacienteItem buscadorPacienteItem--vacio">sin resultados</div>
          ) : (
            filtrados.slice(0, 40).map(p => (
              <div
                key={p.id}
                className={`buscadorPacienteItem${String(p.id) === String(value) ? " buscadorPacienteItem--activo" : ""}`}
                onMouseDown={() => handleSelect(p)}
              >
                <span className="buscadorPacienteNombre">{p.apellido}, {p.nombre}</span>
                <span className="buscadorPacienteInfo">DNI {p.dni} · Socio {p.nroSocio}</span>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  )
}

export default BuscadorPaciente
